import { css } from 'lit';

export const ToujouPortfolioGalleryStyles = css`
  * {
    box-sizing: border-box;
  }

  :host {
    position: relative;
  }
`;